import React, { useEffect, useState } from "react";
import { useToaster } from "../context/ToasterContext";
import { Transition } from '@headlessui/react'
import { CheckCircleIcon, ExclamationCircleIcon, InformationCircleIcon } from '@heroicons/react/24/outline'
import { XMarkIcon } from '@heroicons/react/20/solid'

const Toaster = () => {
  const { toasts, removeToast } = useToaster();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Auto-dismiss toast after 5 seconds
  useEffect(() => {
    const timers = toasts.map((toast) =>
      setTimeout(() => {
        removeToast(toast.id);
      }, 5000)
    );
  
    return () => timers.forEach(clearTimeout);
  }, [toasts]);

  // if(!mounted) {
  //   return null;
  // }

  return (
    <div
      aria-live="assertive"
      className="pointer-events-none fixed inset-0 px-4 py-6 sm:p-6 mb-2"
      style={{ zIndex: '1050' }}
    >
      {toasts.map((toast) => (
        <div className="flex w-full flex-col items-center space-y-4 sm:items-end mb-2" key={toast.id}>
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition show="true">
            <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white dark:bg-black shadow-lg ring-1 ring-black/5 dark:ring-white/5 transition data-[closed]:data-[enter]:translate-y-2 data-[enter]:transform data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-100 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:data-[enter]:sm:translate-x-2 data-[closed]:data-[enter]:sm:translate-y-0">
              <div className="p-4">
                <div className="flex items-start">
                  <div className="shrink-0">
                    {toast.type === 'success' &&
                      <CheckCircleIcon aria-hidden="true" className="size-6 text-green-400 dark:text-green-600" />
                    }
                    {toast.type === 'danger' &&
                      <ExclamationCircleIcon aria-hidden="true" className="size-6 text-red-400 dark:text-red-600" />
                    }
                    {toast.type !== 'success' && toast.type !== 'danger' &&
                      <InformationCircleIcon aria-hidden="true" className="size-6 text-blue-400 dark:text-blue-600" />
                    }
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    {toast.type === 'success' &&
                      <p className="text-sm font-medium text-gray-900 dark:text-gray-100">Success</p>
                    }
                    {toast.type === 'danger' &&
                      <p className="text-sm font-medium text-gray-900 dark:text-gray-100">Error</p>
                    }
                    {toast.type !== 'success' && toast.type !== 'danger' &&
                      <p className="text-sm font-medium text-gray-900 dark:text-gray-100">Info</p>
                    }
                    <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">{toast.message}</p>
                  </div>
                  <div className="ml-4 flex shrink-0">
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeToast(toast.id);
                      }}
                      className="inline-flex rounded-md bg-white text-gray-600 dark:text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2"
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon aria-hidden="true" className="size-5" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      ))}
    </div>
  );
};

export default Toaster;
